import i18n from "i18next";
import { initReactI18next } from "react-i18next";
/**
 * Setting file based on the example given in its documentation:
 * @see https://react.i18next.com/latest/typescript
 * This should be imported in index.tsx and wrapping th App
 */

//JSONS
import de_text from "./de/translation.json";
import en_text from "./en/translation.json";
import es_text from "./es/translation.json";

const resources = {
  de: {
    translation: de_text,
  },
  en: {
    translation: en_text,
  },
  es: {
    translation: es_text,
  },
};

i18n.use(initReactI18next).init({
  lng: "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },
  resources,
});

export default i18n;
